import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="footer">
      <hr />
      <div class="flex flex-col md:flex-row h-auto p-10 justify-center items-center">
        <div class="w-48 h-80 overflow-hidden rounded-2xl relative drop-shadow-xl shadow-md mb-5 md:mr-10">
          <img
            src="chef.jpg"
            alt="Chef Cooking a meal"
            class="absolute object-center object-cover h-full w-full"
          />
        </div>
        <div class="flex flex-row p-1 space-x-10 flex-wrap justify-center">
          <div class="mb-5">
            <h1 class="font-bold font-karla md:mb-8 mb-3">Navigation</h1>
            <div class="font-karla">
              <ul>
                <Link to="/">
                  <li class="my-2 cursor-pointer">Home</li>
                </Link>
                <a href="/#about">
                  <li class="my-2 cursor-pointer">About</li>
                </a>

                <a href="/#specials">
                  <li class="my-2 cursor-pointer">Menu</li>
                </a>

                <a href="/reservations">
                  <li class="my-2 cursor-pointer">Reservations</li>
                </a>

                <a href="/#specials">
                  <li class="my-2 cursor-pointer">Order Online</li>
                </a>

                <a href="/#reviews">
                  <li class="my-2 cursor-pointer">Login</li>
                </a>
              </ul>
            </div>
          </div>
          <div class="flex flex-col justify-start items-start">
            <h1 class="font-bold font-karla md:mb-8 mb-3">Contact</h1>
            <div class="mb-5">
              <a
                href="https://tinyurl.com/yw69puuk"
                target="_blank"
                rel="noreferrer"
              >
                <h2>123 Cuisine St</h2>
              </a>
              <a href="tel:18008675309">
                <h2>{`(800) 867-5309`}</h2>
              </a>
              <a
                href="mailto:info@littlelemon.com"
                target="_blank"
                rel="noreferrer"
              >
                <h2>info@littlelemon.com</h2>
              </a>
            </div>
          </div>

          <div class="flex flex-col justify-start items-center">
            <h1 class="font-bold font-karla md:mb-6 mb-3">
              Social Media Links
            </h1>
            <div class="flex flex-row space-x-2 justify-center items-center">
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <img src="facebook.png" alt="Facebook" class="w-10" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <img src="instagram.svg" alt="Instagram" class="w-10" />
              </a>
              <a href="https://threads.net" target="_blank" rel="noreferrer">
                <img src="threads.png" alt="Threads" class="w-10" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <h2 class="flex justify-center items-center font-karla text-xs mt-5">
        ©️2023 JRL Meta Capstone Project
      </h2>
    </footer>
  );
};

export default Footer;
